/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { AddFittingComponent } from '../add-fitting-size/add-fitting.component';
import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { DialogBoxComponent } from '../../shared/dialog-box/dialog-box.component';

import { UserHandlerService } from '../../sharedServices/user-handler.service';

import { GenericTableData } from '../../sharedServices/generic-table-data.service';
import { FittingSizeDataService } from '../../sharedServices/fittingSize-data.service';
import { FittingSizeManagementService } from '../../sharedServices/fitting-size-management.service';
import { AuthentificationService } from '../../sharedServices/authentification.service';
import { LoaderService } from '../../sharedServices/loader.service';
import { ActionPageEnumDto, FittingDto, ActionTypeEnumDto } from 'api/models';
import { FittingsManagementService } from 'api/services';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fitting-approval-page',
  templateUrl: './fitting-approval-page.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FittingApprovalPageComponent extends AddFittingComponent
  implements OnInit {
  columnHeader = {
    fittingEntryID: 'Fitting Entry ID',
    manufacturerName: 'Manufacturer Name',
    productLineName: 'ProductLine Name',
    longDescription: 'Long Description',
    fileName: 'File Name ',
    status: 'Status',
    requestBy: 'Request By',
    unitsName: 'Units Name'
  };

  ngOnInit() {
    this.refreshSubscription = this.fittingSizeManagementService.
      getFittingTableData().subscribe(
        () => {
          this.refresh();
          this.selectedRowCopy = this.fittingSizeManagementService.getSelectedRowCopy();
        }
      );
    this.actionPage = ActionPageEnumDto.Approval;
    this.resetExistingFittingSizeDataTable();
    this.setTableHeaders();
    this.getFittingsData();
    this.fittingSizeManagementService.setActionPage(this.actionPage);

  }

  constructor(
    public dialog: MatDialog,
    public userHandlerService: UserHandlerService,
    public fittingsManagementService: FittingsManagementService,
    public genericTableDataService: GenericTableData,
    public fittingSizeDataService: FittingSizeDataService,
    public fittingSizeManagementService: FittingSizeManagementService,
    public authentificationService: AuthentificationService,
    public loaderService: LoaderService
  ) {
    super(dialog, userHandlerService, fittingsManagementService, genericTableDataService,
      fittingSizeDataService, fittingSizeManagementService, authentificationService, loaderService);
  }

  getFittingType() {
    return this.fittingSizeManagementService.getSelectedFittingType();
  }

  getFittingsData() {
    this.loaderService.display(true);
    this.fittingsManagementService.getRecordsForApproval(
      {
        actionPageDto: this.actionPage
      }
    )
      .subscribe(result => {
        this.genericTableDataService.setTableDataList(result);
        this.loaderService.display(false);
      });
  }

  onRejectActionClick(element: FittingDto) {
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      data: {
        title: 'Reject action',
        comment: '',
        message: 'Do you want to reject this fitting?',
        addComment: true
      }
    });
    this.handleActionButton(dialogRef, element, 'Reject');
  }

  onApproveActionClick(element: FittingDto) {
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      data: {
        title: 'Approve action',
        comment: '',
        message: 'Do you want to approve this fitting?',
        addComment: true
      }
    });
    this.handleActionButton(dialogRef, element, 'Approve');
  }

  handleActionButton(
    dialogRef: MatDialogRef<DialogBoxComponent, any>,
    element,
    actionType: string
  ) {
    const subscribeOk = dialogRef.componentInstance.okClickEvent.subscribe(
      () => {
        if (
          dialogRef.componentInstance.data.addComment &&
          dialogRef.componentInstance.data.comment !== '' &&
          dialogRef.componentInstance.data.comment !== undefined
        ) {
          switch (actionType) {
            case 'Approve':
              this.onApproveAction(
                element,
                dialogRef.componentInstance.data.comment
              );

              break;
            case 'Reject':
              this.onRejectAction(
                element,
                dialogRef.componentInstance.data.comment
              );

              break;
          }
        } else {
          this.fittingSizeManagementService.openSnackBar(
            'Add a comment before rejecting or approving a fitting'
          );
        }
      }
    );
    dialogRef.afterClosed().subscribe(() => {
      subscribeOk.unsubscribe();
    });
  }

  onRejectAction(element: FittingDto, comment: string) {
    let nextActionType: ActionTypeEnumDto;

    switch (element.statusID) {
      case ActionTypeEnumDto.SendForApproveAdd:
        nextActionType = ActionTypeEnumDto.RejectedAddedSize;
        break;
      case ActionTypeEnumDto.SendForApproveDeletedSize:
        nextActionType = ActionTypeEnumDto.RejectedDeletedSize;
        break;
      case ActionTypeEnumDto.SendForApproveUpdatedSize:
        nextActionType = ActionTypeEnumDto.RejectedUpdatedSize;
        break;
    }
    this.fittingsManagementService.updateApprovalStatus(
      {
        userId: this.userHandlerService.getCurrentUserId(),
        bdToolId: element.bdToolID,
        actionTypeEnumDto: nextActionType,
        fittingEntryId: element.fittingEntryID,
        comment
      }
    ).subscribe(() => {
      this.getFittingsData();
      this.fittingSizeManagementService.openSnackBar(
        'Fitting has been rejected succesfully'
      );
    });
  }

  onApproveAction(element: FittingDto, comment: string) {
    let nextActionType: ActionTypeEnumDto;
    switch (element.statusID) {
      case ActionTypeEnumDto.SendForApproveAdd:
        nextActionType = ActionTypeEnumDto.ApprovedAddedSize;
        break;
      case ActionTypeEnumDto.SendForApproveDeletedSize:
        nextActionType = ActionTypeEnumDto.ApprovedDeletedSize;
        break;
      case ActionTypeEnumDto.SendForApproveUpdatedSize:
        nextActionType = ActionTypeEnumDto.ApprovedUpdatedSize;
        break;
    }
    this.fittingsManagementService.updateApprovalStatus(
      {
        userId: this.userHandlerService.getCurrentUserId(),
        bdToolId: element.bdToolID,
        actionTypeEnumDto: nextActionType,
        fittingEntryId: element.fittingEntryID,
        comment
      }
    ).subscribe(() => {
      this.getFittingsData();
      this.fittingSizeManagementService.openSnackBar(
        'Fitting has been approved succesfully'
      );
    });
  }
}
